const isArray = Array.isArray;
const hasValue = (value) => typeof value !== 'undefined' && value !== null;
const isFunction = (value) => typeof value === 'function';
const isObject = (value) => !!value && !isArray(value) && typeof value === 'object';
const isString = (value) => typeof value === 'string';
const isStringArray = (value) => isArray(value) && value.length > 0 && value.every(x => isString(x));
const isNumber = (value) => typeof value === 'number';
const isStatusCode = (statusCodes, status) => hasValue(status) &&
    ((isArray(statusCodes) && statusCodes.indexOf(status) !== -1) ||
        (isNumber(statusCodes) && statusCodes === status));
const isAbortSignal = (signal) => {
    const proto = !!signal && typeof signal === 'object' && Object.getPrototypeOf(signal);
    // Fail-safe fallback, is required to work with some browsers that do not have native implementation of AbortSignal
    const isCompatible = !!signal &&
        typeof signal.aborted !== 'undefined' &&
        typeof signal.onabort !== 'undefined';
    return (!!(proto && proto.constructor.name === 'AbortSignal') || isCompatible);
};

export { hasValue, isAbortSignal, isArray, isFunction, isNumber, isObject, isStatusCode, isString, isStringArray };
